<template>
  <div v-bind:class="((auth.user.role == 'ADMIN'))  ? '' : 'viewonly'">
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/daylogs">Day Logs</Link> (<span class="jobsite-name"></span>)
      <span class="text-indigo-400 font-medium">/</span>
      {{ getDayString(form.reportday) }}
    </h1>
    <trashed-message v-if="daylog.deleted_at" class="mb-6" @restore="restore"> This Day Log has been deleted. </trashed-message>
    <div id="bigloading" class="max-w-3xl bg-white rounded-md shadow overflow-hidden loading">
      <form @submit.prevent="update" autocomplete="off">
        <div class="flex flex-wrap p-4">

          <SelectInput class="pb-8 pr-6 w-1/4 noprint hide" id="jobsite_id" v-model="form.jobsite_id" disabled="disabled"><option>--Select a Jobsite--</option><option v-for="jobsite in jobsites.data" :value="jobsite.id">{{jobsite.sitename}}</option></SelectInput><br/><br/>
          <span class="pb-8 pr-6 w-full lg:w-1/5 hide inline-block">
            Report Day:<br/>
            <datepicker v-model="form.reportday" disabled="disabled" :enableTimePicker="false" autoApply :error="form.errors.reportday" class="mt-2" label="Report Day" />
          </span>
          <text-input v-model="form.superintendent" :error="form.errors.superintendent" class="pb-8 pr-6 sm:w-full md:w-1/2 inline-block" label="Superintendent" />
          <div class="sm:w-full md:w-1/2 inline-block">
            <text-input v-model="form.temp_low" type="number" :error="form.errors.temp_low" class="pb-8 pr-4 w-1/3 inline-block" label="Low Temp" />
            <text-input v-model="form.temp_high" type="number" :error="form.errors.temp_high" class="pb-8 pr-4 w-1/3 inline-block" label="High Temp" />
            <text-input v-model="form.other_weather" :error="form.errors.other_weather" class="pb-8 pr-2 w-1/3 inline-block" label="Other Weather" />
          </div>
          <div class="w-full">
            
            <label for="crain" class="pb-8 pr-6 mr-4 mb-4 nobreak">
              Rain
              <input type="checkbox" id="crain" v-model="form.rain" :error="form.errors.rain" label="Rain" />
            </label>
            <label for="crain" class="pb-8 pr-6 mr-4 mb-4 nobreak">
              Snow
              <input type="checkbox" id="csnow" v-model="form.snow" :error="form.errors.snow" label="Snow" />
            </label>
            <label for="crain" class="pb-8 pr-6 mr-4 mb-4 nobreak">
              Ice
              <input type="checkbox" id="cice" v-model="form.ice" :error="form.errors.ice" label="Ice" />
            </label>
            <label for="crain" class="pb-8 pr-6 mr-4 mb-4 nobreak">
              Wind
              <input type="checkbox" id="cwind" v-model="form.wind" :error="form.errors.wind" label="Wind" />
            </label>
            <label for="crain" class="pb-8 pr-6 mr-4 mb-4 nobreak">
              Sun
              <input type="checkbox" id="csun" v-model="form.sun" :error="form.errors.sun" label="Sun" />
            </label>
            <label for="crain" class="pb-8 pr-6 mr-4 mb-4 nobreak">
              Lost Production
              <input type="checkbox" id="lostday"  v-model="form.lostday" :error="form.errors.lostday" label="Lost Production" />
            </label>
            
          </div>
          <div class="w-full pb-4 gallery-container" id="progphotos">
            <h4 class="mb-4">Daylog/Progress Photos</h4>
            <textarea id="uploadstring" class="hide"></textarea>
            <div class="newfolderbox" v-if="(auth.user.role !== 'VENDOR')">
              <sub><i>Alphanumeric and spaces only</i></sub>
              <input style="" id="newfolder" name="newfolder" type="text" placeholder="Folder Name"/><button @click="createFolder($event);" class="signature-button p-2 mb-2 bg-yellow-200 font-bold noprint">Add</button>
            </div>
            <input class="hide" type="file" ref="progphotos" id="uploader" multiple v-bind:accept='acceptString' @input="
      $event.preventDefault(); parsePhotos($event,foldername)" />
            <div class="progphotos-gallery gallery"></div>
          </div>
          <div class="w-full pb-4">
            <div class="pb-4">Equipment Rentals & Material Deliveries for Subcontractors</div>
            <textarea @input="resize('textarea1')" @onload="resize('textarea1')"  id="textarea1" v-model="form.rentals_deliveries" :error="form.errors.rentals_deliveries" class="pb-8 pr-6 w-full"  ></textarea>
          </div>
          <div class="w-full pb-4">
            <div class="pb-4">Hindrance to Normal Progress</div>
            <textarea @input="resize('textarea3')" @mount="resize('textarea2')"  id="textarea2" v-model="form.hinderance_notes" :error="form.errors.hinderance_notes" class="pb-8 pr-6 w-full" label="Hindrance Notes" ></textarea>
          </div>
          <div class="w-full pb-4">
            <div class="pb-4">Additional Notes</div>
            <textarea @input="resize('textarea3')" @mount="resize('textarea3')"  id="textarea3" v-model="form.additional_notes" :error="form.errors.additional_notes" class="pb-8 pr-6 w-full" label="Additional Notes" ></textarea>
          </div>

          <div class="w-full pb-4" id="workers">
            <div class="w-full mb-4">
              <h2 class="mb-4 text-2xl font-bold">Worker Summary</h2> 
              <button v-if="(auth.user.role == 'ADMIN' || auth.user.role == 'USER')" class="signature-button p-2 mb-2 bg-yellow-200 font-bold noprint" @click="addRow">Add Row</button>
              <div id="workersumtable" class=""></div>
              <text-input v-model="form.workersummary" :error="form.errors.workersummary" id="workersum"  class="pb-8 pr-6 w-full lg:w-1/2 hide" label="Worker Summary JSON" />
            </div>
          </div>

        </div>


        <div class="flex flex-wrap mb-4 p-4 noprint">
          
          <h2 class="mb-4 text-2xl font-bold">Shipment Receipt</h2> 

          <template v-for="order in orders">
          <div v-bind:id="'orderid-' + order.id" class="order" v-if="(auth.user.vendor == getOrderVendor(order.purchaseorder_id) || auth.user.vendor == 0)">
          <table :class='(opened[order.id] != 1) ? "" : "hide"'>
            <tr>
              <th colspan="7" class="order-header">Order # {{ order.id }} {{ getOrderString(order.purchaseorder_id) }} <span style="position:absolute; right:60px;">{{ moment(order.orderdate).format('MM/DD/YYYY') }}</span> <span @click="(opened[order.id] == 1) ? opened[order.id] = 0 : opened[order.id] = 1; showOrder(order.id);" class="opener">+</span></th>
            </tr>
          </table>
            <template v-if="(auth.user.vendor == order.vendor || auth.user.vendor == 0)">
              <table v-show="(opened[order.id])">
                <tr>
                  <th colspan="7" class="order-header">Order # {{ order.id }} {{ getOrderString(order.purchaseorder_id) }} <span style="position:absolute; right:60px;">{{ moment(order.orderdate).format('MM/DD/YYYY') }}</span> <span @click="(opened[order.id] == 1) ? opened[order.id] = 0 : opened[order.id] = 1; showOrder(order.id);" class="opener">-</span></th>
                </tr>
                <tr>
                  <th class="px-1 prodsize">TxWxL</th>
                  <th>Item </th>
                  <th>PO Qty</th>
                  <th>Order<br/> Qty</th>
                  <th>Proj. Net</th>
                  <th>Rcvd Before {{ moment(form.reportday).format('M/D/Y') }}</th>
                  <th>Qty&nbsp; Received {{ moment(form.reportday).format('M/D/Y') }}</th>
                </tr>
                <template v-for="(product, loop) in (JSON.parse(order.products || '[]'))">
                  <tr v-bind:notordered='(product.qty_ordered > 0)' class="inventory-row" v-bind:id="'inventory-row-' + order.id + '-' + (loop+1)">
                    <td class="px-1 prodsize" style="max-width:100px">{{product.sizet}}<span class="text-xs"> x </span>{{product.sizew}}<span class="text-xs"> x </span>{{product.sizel}}{{product.span}}</td>
                    <td class="px-1 text-sm itemdesc">{{product.itemdesc}}{{product.description}}</td>
                    <td class="px-1 po-qty text-right" v-bind:id="'inv-po-' + order.id + '-' + (loop+1)" >{{ }}</td>
                    <td class="px-1 start-qty text-right" v-bind:id="'inv-original-' + order.id + '-' + (loop+1)" >{{ product.qty_ordered }}</td>
                    <td :class="'px-1 curr-qty netproj text-right ' + (order.ordertype != 'TRUSS' ? '' : 'hide')" v-bind:id="'inv-current-' + order.id + '-' + (loop+1)" >{{ }}</td>
                    <td class="px-1 qtytodate" v-bind:id="'inv-qtytodate-' + order.id + '-' + (loop+1)" ></td>
                    <td class="inventory-delta text-center">
                      <input type="text" @keypress="isPos($event)" class="inv-adder text-right"
                        :id="'inv-adder-' + order.id + '-' + (loop+1)"
                        @change="newtotalAdd(order.id,(loop+1))"
                      /> 

                    </td>
                  </tr>
                </template>

                <tr class="w-full pb-4 gallery-container" colspan="4">
                    <h3 class="m-2">Shipment Delivery</h3>
                    <input class="m-2" type="file" @ref="'orderphotos-' + order.id" multiple v-bind:accept='acceptString' @input="parsePhotos($event)" />
                    <div class="inventory-gallery gallery"></div>
                  </tr>
              </table>
            </template>
          </div>
          </template>

          <div class="w-full mb-4 pr-6">
            <div id="orderstable" class=""></div>
            <text-input v-show="true" v-model="form.products" id="productsdata" class="hide" :error="form.errors.products" />
          </div>

          <div class="w-full nobreak noprint">
            <h2 class="mb-4 text-2xl font-bold">Driver Delivery Confirmation</h2>
            <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'auto'" :h="'200px'" 
                :disabled="state.disabled" 
                :defaultUrl="form.signature"
                 class="pr-6 nobreak"></Vue3Signature>
            <button v-if="(auth.user.role == 'ADMIN' || auth.user.role == 'USER')" class="signature-button p-2 mb-8 bg-yellow-200 font-bold noprint" @click="clear">Clear</button>&nbsp; 
            <button v-if="(auth.user.role == 'ADMIN' || auth.user.role == 'USER')" class="signature-button p-2 mb-8 bg-green-200 font-bold noprint" @click="save">Save</button>&nbsp; 
            <text-input v-show="true" v-model="form.signature" id="signaturedata" class="hide" :error="form.errors.signature" />
          </div>
          
        </div>

    

        <text-input v-model="form.progress" :error="form.errors.progress" class="pb-8 pr-6 w-full lg:w-1/2 hide" label="Progress JSON" />
        <text-input v-model="form.orderupdates" :error="form.errors.orderupdates" class="pb-8 pr-6 w-full lg:w-1/2 hide" label="Order Updates JSON" />

        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100 noprint">
          <button v-if="(auth.user.role == 'ADMIN' && !daylog.deleted_at)" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Day Log</button>
          <loading-button v-if="(auth.user.role == 'ADMIN' || auth.user.role == 'USER')" :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Day Log</loading-button>
        </div>
        
      </form>
    </div>
  </div>
</template>
<style>
  table { width:100%; }
  .inv-changer { border:2px solid #f5d1d1; margin-bottom:0; }
  .inv-adder { border:2px solid #d1f5d1; margin-bottom:0; }
  .hide { display:none !important; opacity:0 !important; pointer-events:none !important; }
  .inventory-row { border-bottom:1px solid #333; }
    .inventory-row td { margin:0; padding:0px 2px; }
      .inventory-row input { padding:0 10px; font-weight:bold; width:90px; margin:0 10px; }
  .order { border:1px solid #333; margin-bottom:40px; width:100%; }
    .order th { line-height:0; padding-bottom:10px; padding-top:10px; line-height:20px; }
  .prodsize { min-width:80px; font-size:12px; width:80px; }
  .start-qty { width:80px; color:#999; }
  .opener { color:#FFF; float:right; background:#333; padding:8px 10px; display:inline-block; cursor:pointer; margin-right:5px; width:32px; text-align:center; }

.qtytodate { text-align:right; }  
.netproj { color:#00a8cd; font-weight:bold; color:#005c70;  }
  .inventory-delta { width:35%;  }
  .itemdesc { width:auto; }
  .onlyprint { display:none; }
  .tabulator .tabulator-tableholder { overflow:hidden; }
  .order-header {
    text-align:left; background:#A9A9A9; margin:5px; position:relative;
  }
  tr[notordered="false"] { display:none; }

  #progphotos { position:relative; display:block; }

  .imageprev:not(.lightbox-clicked) {
    max-width:125px;
    display:inline-block;
    margin:12.5px;
    position:relative;
  }
  .imageprev:not(.lightbox-clicked) .delete {
    display:none;
  }
  .imageprev.lightbox-clicked {
    position:fixed;
    top:0;
    left:0;
    padding:5%;
    z-index:5;
    width:100%;
    height:100%;
  }
  .imageprev.lightbox-clicked .lightbox {
    z-index:6;
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    overflow:hidden;
    padding:5%;
    background:#111111ED;
  }
  .imageprev.lightbox-clicked img {
    margin:0% auto;
    max-height: 100%;
    max-width: 100%;
  }

  .imageprev:hover {
    cursor:pointer;
  }
  .delete::after {
    background:#FEFEFE;
    content: 'DELETE';
    position:absolute;
    bottom:25px;
    left:25px;
    color:#a01300;
    font-weight:bold;
    cursor:pointer;
    position:absolute;
    font-size:32px;
    font-family:verdana;
    padding:5px;
    border:2px solid #FFF;
  }
  input[type="file"] { color:#CCCCCC00; width:110px; }
  label.nobreak {
    display:inline-block;
  }

  .hide { display:none !important; opacity:0 !important; pointer-events:none !important; }
  .loadingsm {
    height:5px;
    opacity:0.1;
    pointer-events:none;
    background:#777777;
  }
  .loading {
    opacity:0.3;
    pointer-events:none;
		background: url('data:image/svg+xml;base64,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') 50% 50% no-repeat rgb(249,249,249);
  }

  .viewonly .workerdelete, .viewonly #workers button  { display:none; }
  .viewonly .noprint button { display:none; }
  .viewonly input[type="file"] { display:none; }

  .directory { padding:10px 15px 15px 15px; margin:50px 0; border:2px solid #13B7E0; position:relative; min-height:65px; display:block; 
    max-height:100px;
  }
  .directory img { display:none; }
  .directory.loaded img { display:inline-block; }
  .directory.loaded { max-height:initial; }
  .directory h3 { position:absolute; top:-24px; left:-2px; background:#13B7E0; color:#FFF; font-weight:bold; padding:3px 5px;  }
  .loadbutton { background:#09586c; color:#FFF; font-weight:bold; padding:4px; }
  .uploadbutton { float:right; background:#FEF08A; color:black; font-weight:bold; padding:5px 8px; visibility:hidden; }
  .directory.loaded .uploadbutton { visibility:visible; }
  .deletebutton { position:absolute; top:-26px; left:42%; background:#cd4d1b; color:#FFF; font-weight:bold; padding:5px 8px; }
  .gallery { position:relative; }
  .newfolderbox {
    position:absolute; right:0; top:0;
  }
  .newfolderbox sub {
    position:absolute; top:-7px; right:65px; height:10px;
  }
  @media screen and (max-width:640px) {
    .newfolderbox {
      position:initial;
      max-width:250px;
    }
    .newfolderbox sub {
      position:initial;
    }
  }    
/* PRINT */
@media print {
  .onlyprint { display:initial; }
  .noprint, #mainmenu { display:none; }
  #ordercontainer {box-shadow:none !important; }
  .nobreak, .nobreak canvas, .nobreak * { page-break-inside: avoid; }
  svg.dp__icon { display:none; }
  .tabulator-cell svg { display:none; }
  .text-3xl { font-size:1.4rem; }
  * { overflow:hidden !important; }
}
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from '@vuepic/vue-datepicker';
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import moment from 'moment'
import '@vuepic/vue-datepicker/dist/main.css';
import Vue3Signature from "vue3-signature"
//import { type } from 'os'


export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker,
  },
  layout: Layout,
  props: {
    daylog: Object,
    orders: Object,
    purchaseorders: Object,
    jobsites: Object,
    auth: Object,
    daylogs: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
            jobsite_id: this.daylog.jobsite_id,
            superintendent: this.daylog.superintendent,
            temp_low: this.daylog.temp_low + "",
            temp_high: this.daylog.temp_high + "",
            rain: this.daylog.rain,
            snow: this.daylog.snow,
            ice: this.daylog.ice,
            wind: this.daylog.wind,
            sun: this.daylog.sun,
            lostday: this.daylog.lostday,
            other_weather: this.daylog.other_weather,
            rentals_deliveries: this.daylog.rentals_deliveries,
            hinderance_notes: this.daylog.hinderance_notes,
            additional_notes: this.daylog.additional_notes,
            progress: this.daylog.progress,
            reportday: this.reportdaylocal(this.daylog.reportday),
            orderupdates: this.daylog.orderupdates,
            signature: this.daylog.signature,
            workersummary: this.daylog.workersummary,
            attachments: this.daylog.attachments,
      }),
      imageform: this.$inertia.form({
        '_method': 'PUT',
              gallerytype: null,
              fname: null,
              upfile: null,
              foldername: null,
              jobsite: null,
              daylog: null,
          }, {
          resetOnSuccess: true,
      }),
      deleteimageform: this.$inertia.form({
        imagepath: null,
      }, { resetOnSuccess: true }),
      moment: moment,
      acceptString: ".jpg, .jpeg, .png, .webm, .webp, .mp4, .mov, .mpeg4, .flv, .mkv, .m4v",
      opened: [],
    }
  },
  mounted:function(){
       this.initAllProductsDeltas();
       
        window.setTimeout(function() {
          //this.qtyCurrent();
          var jsid = document.querySelector('#jobsiteselector').options.selectedIndex;
          var jstext = document.querySelector('#jobsiteselector').options[jsid].text;
          document.querySelector('.jobsite-name').textContent = jstext;
        },1);
        window.setTimeout(this.qtyCurrent(), 50);
          //this.getPhotos(); runs after deltas
  },
  methods: {
    getOrderVendor(orderpo) {
      var rvendor;
      this.purchaseorders.data.forEach( (v) => {
        if (v.id == orderpo) {
          rvendor = v.vendor;
        } 
      });
      return rvendor;
    },
    getOrderType(orderpo) {
      var otype;
      this.purchaseorders.data.forEach( (v) => {
        if (v.id == orderpo) {
          otype = v;
        } 
      });
      //console.log(otype);
      return otype.ordertype;
    },
    getOrderString(orderpo) {
      var string = '';
      this.purchaseorders.data.forEach( (v) => {
        if (v.id == orderpo) {
          if (v.ordertype == 'TRUSS') {
            string = '[' + v.ordertype + ']' + ' Building ' + v.building + ' ' + v.floor + ' ' + v.bid_id;
          }
          else {
            string = '[' + v.ordertype + ']';
          }
        } 
      });
      return '' + string;
    },
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    showOrder(orderid) {
      document.querySelector('#orderid-' + orderid + ' .opener:not(.hide)').textContent;
      if (document.querySelector('#orderid-' + orderid + ' table:not(.hide) .opener').textContent == '-') {
        document.querySelector('#orderid-' + orderid).classList.remove('hide');
      } else {
        this.calcNetForOrder(orderid);
      }      
    },
    calcNetForOrder(orderid) {
      var jobsiteonform = this.form.jobsite_id;
      var formday = moment(this.form.reportday,'MM/DD/YYYY').format('YYYYMMDD');
      var rowups = [];
      this.daylogs.data.forEach(function(v,k) {
        if (v.orderupdates) {
          if (v.jobsite_id == jobsiteonform) {
            if (v.reportday < formday) {
              try {
                var oups = JSON.parse(JSON.stringify(JSON.parse(v.orderupdates).ordersAdd));
                oups[orderid].forEach(function(v2,k2) {
                  if (typeof(rowups[k2+1]) !== 'number') { rowups[k2+1] = 0; }
                  rowups[k2+1] += v2; //console.log(parseInt(v2));
                });
              } catch(e) { console.warn(e); }
            }
          }
        }
      });
      rowups.forEach(function(v,k) {
        document.querySelector('#inv-qtytodate-' + orderid + '-' + k).textContent = v;
      });
      document.querySelector('#orderid-' + orderid).classList.remove('hide');
    },
    getPhotos() {
      this.daylog.dirs.forEach((dirname) => { 
        var directory = document.createElement('div');
        directory.classList.add('directory');
        var dirtitle = document.createElement('h3');
        dirtitle.classList.add('foldertitle');
        var dirnamecheck = dirname.split('/')[3];
         
        if (typeof(dirnamecheck) !== 'undefined') {
          var gtype = dirname.split('/')[2];
          var uploadclicker = document.createElement('button');
          uploadclicker.classList.add('uploadbutton');
          uploadclicker.setAttribute('gtype',gtype);
          uploadclicker.setAttribute('dirname',dirnamecheck);
          uploadclicker.innerText = 'Upload';
          uploadclicker.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector('#uploader').setAttribute('gofolder',dirnamecheck);
            document.querySelector('#uploader').click();
          });
          if (this.auth.user.role !== 'VENDOR') {
          var deleteclicker = document.createElement('button');
          deleteclicker.classList.add('deletebutton');
          deleteclicker.setAttribute('gtype',gtype);
          deleteclicker.setAttribute('dirname',dirnamecheck);
          deleteclicker.innerText = 'Delete Folder';
          deleteclicker.addEventListener("click", (e) => {
            //var gtype = e.target.getAttribute('gtype');
            this.deleteFolder(e);
          });
          }
          
          var loadbutton = document.createElement('button');
          loadbutton.classList.add('loadbutton');
          loadbutton.innerText = '+';
          loadbutton.addEventListener("click", (e) => {
            e.preventDefault();
            e.target.parentElement.classList.add('loaded');
            e.target.parentElement.childNodes.forEach(function(v,k) {
              if (v.classList == 'imageprev') {
                //console.log(v.childNodes[0].lastChild);
                v.childNodes[0].lastChild.setAttribute('src',v.childNodes[0].lastChild.getAttribute('srcs'));
                loadbutton.classList.add('hide');
              }
            });
          });
          
          dirtitle.innerText = dirnamecheck;
          directory.setAttribute('dirname',dirnamecheck);
          directory.appendChild(dirtitle);
          directory.appendChild(loadbutton);
          directory.appendChild(uploadclicker);
          if (this.auth.user.role !== 'VENDOR') {
            directory.appendChild(deleteclicker);
          }
          if (gtype == 0) {
            var galselector = '#progphotos .progphotos-gallery.gallery';
          } else if (gtype > 0) {
            var galselector = '#orderid-' + gtype + ' .inventory-gallery.gallery';
          }
          document.querySelector(galselector).appendChild(directory);
        }
      });
      this.daylog.imagelist.forEach((imagesource, imgkey) => { 
        //0:"daylogs/21/0/Screen Shot 2020-10-01 at 3.05.55 PM.png"
        //1:"daylogs/21/0/technology-logo-generator-for-media-consulting-companies-597c-el1 (15) (1).png"
        var daylogid = imagesource.split('/')[1];
        var imagetype = imagesource.split('/')[2];
        var ifilename = imagesource.split('/')[4];
        if (typeof(ifilename) == 'undefined') {
          var foldername = '';
          ifilename = imagesource.split('/')[3];
        } else {
          var foldername = imagesource.split('/')[3] + '/';
        }
        
       
        var imgprev = document.createElement('span'); imgprev.classList.add("imageprev");
        var ilbox = document.createElement('span'); ilbox.classList.add('lightbox');

        if (this.auth.user.role == 'ADMIN') {
          var ilboxdeleteimg = document.createElement('span'); ilboxdeleteimg.classList.add('delete');
          ilboxdeleteimg.addEventListener("click", (e) => {
            this.deleteimageform.imagepath = this.daylog.jobsite_id + '/' + imagetype + '/' + foldername + ifilename;
            this.deleteimageform.put(`/daylogs/${this.daylog.id}/deletephoto/`);
            e.target.parentElement.parentElement.remove();
          });
          ilbox.appendChild(ilboxdeleteimg);
        }
        imgprev.appendChild(ilbox);

        var img = document.createElement('img');
        var srcs = '/daylogsmall.php?p=' + this.daylog.jobsite_id + '/' + imagetype + '/' + foldername + ifilename;
        var srci = '/daylogi.php?p=' + this.daylog.jobsite_id + '/' + imagetype + '/' + foldername + ifilename;
        if (imagetype == 0) {
          img.setAttribute('src','https://placehold.co/100?text=Loading...');
        } else {
          img.setAttribute('src',srcs);  
        }
        img.setAttribute('srci',srci);
        img.setAttribute('srcs',srcs);
        img.addEventListener("click", (e) => {
          if (document.getElementsByClassName('lightbox-clicked').length > 0) {
            e.target.parentElement.parentElement.classList.remove('lightbox-clicked');
            img.setAttribute('src',srcs);
          } else {
            e.target.parentElement.parentElement.classList.add('lightbox-clicked');
            img.setAttribute('src',srci);
          }
        });
        ilbox.appendChild(img);
        if (imagetype == 0) {
          if (foldername.length > 0) {
            
          if (this.auth.user.role !== 'VENDOR') {
            document.querySelector("#progphotos .gallery .directory[dirname='" + foldername.split('/')[0] + "'] .deletebutton").classList.add('hide');
          }
            document.querySelector("#progphotos .gallery .directory[dirname='" + foldername.split('/')[0] + "']").appendChild(imgprev);
          } else {
            document.querySelector("#progphotos .gallery").appendChild(imgprev);
          }
          
        }
        else {
          document.querySelector("#orderid-" + imagetype + ' .gallery').appendChild(imgprev);
        }
      });
    },
    getPhotosForOrder() {
      try {
      this.daylog.dirs.forEach((dirname) => { 
        var directory = document.createElement('div');
        directory.classList.add('directory');
        var dirtitle = document.createElement('h3');
        dirtitle.classList.add('foldertitle');
        var dirnamecheck = dirname.split('/')[3];
         
        if (typeof(dirnamecheck) !== 'undefined') {
          var gtype = dirname.split('/')[2];
          var uploadclicker = document.createElement('button');
          uploadclicker.classList.add('uploadbutton');
          uploadclicker.setAttribute('gtype',gtype);
          uploadclicker.setAttribute('dirname',dirnamecheck);
          uploadclicker.innerText = 'Upload';
          uploadclicker.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector('#uploader').setAttribute('gofolder',dirnamecheck);
            document.querySelector('#uploader').click();
          });
          if (this.auth.user.role !== 'VENDOR') {
          var deleteclicker = document.createElement('button');
          deleteclicker.classList.add('deletebutton');
          deleteclicker.setAttribute('gtype',gtype);
          deleteclicker.setAttribute('dirname',dirnamecheck);
          deleteclicker.innerText = 'Delete Folder';
          deleteclicker.addEventListener("click", (e) => {
            //var gtype = e.target.getAttribute('gtype');
            this.deleteFolder(e);
          });
          }
          
          var loadbutton = document.createElement('button');
          loadbutton.classList.add('loadbutton');
          loadbutton.innerText = '+';
          loadbutton.addEventListener("click", (e) => {
            e.preventDefault();
            e.target.parentElement.classList.add('loaded');
            e.target.parentElement.childNodes.forEach(function(v,k) {
              if (v.classList == 'imageprev') {
                //console.log(v.childNodes[0].lastChild);
                v.childNodes[0].lastChild.setAttribute('src',v.childNodes[0].lastChild.getAttribute('srcs'));
                loadbutton.classList.add('hide');
              }
            });
          });
          
          dirtitle.innerText = dirnamecheck;
          directory.setAttribute('dirname',dirnamecheck);
          directory.appendChild(dirtitle);
          directory.appendChild(loadbutton);
          directory.appendChild(uploadclicker);
          directory.appendChild(deleteclicker);
          if (gtype == 0) {
            var galselector = '#progphotos .progphotos-gallery.gallery';
          } else if (gtype > 0) {
            var galselector = '#orderid-' + gtype + ' .inventory-gallery.gallery';
          }
          document.querySelector(galselector).appendChild(directory);
        }
      });
      this.daylog.imagelist.forEach((imagesource, imgkey) => { 
        //0:"daylogs/21/0/Screen Shot 2020-10-01 at 3.05.55 PM.png"
        //1:"daylogs/21/0/technology-logo-generator-for-media-consulting-companies-597c-el1 (15) (1).png"
        var daylogid = imagesource.split('/')[1];
        var imagetype = imagesource.split('/')[2];
        var ifilename = imagesource.split('/')[4];
        if (typeof(ifilename) == 'undefined') {
          var foldername = '';
          ifilename = imagesource.split('/')[3];
        } else {
          var foldername = imagesource.split('/')[3] + '/';
        }
        
       
        var imgprev = document.createElement('span'); imgprev.classList.add("imageprev");
        var ilbox = document.createElement('span'); ilbox.classList.add('lightbox');

        if (this.auth.user.role == 'ADMIN') {
          var ilboxdeleteimg = document.createElement('span'); ilboxdeleteimg.classList.add('delete');
          ilboxdeleteimg.addEventListener("click", (e) => {
            this.deleteimageform.imagepath = this.daylog.jobsite_id + '/' + imagetype + '/' + foldername + ifilename;
            this.deleteimageform.put(`/daylogs/${this.daylog.id}/deletephoto/`);
            e.target.parentElement.parentElement.remove();
          });
          ilbox.appendChild(ilboxdeleteimg);
        }
        imgprev.appendChild(ilbox);

        var img = document.createElement('img');
        var srcs = '/daylogsmall.php?p=' + this.daylog.jobsite_id + '/' + imagetype + '/' + foldername + ifilename;
        var srci = '/daylogi.php?p=' + this.daylog.jobsite_id + '/' + imagetype + '/' + foldername + ifilename;
        if (imagetype == 0) {
          img.setAttribute('src','https://placehold.co/100?text=Loading...');
        } else {
          img.setAttribute('src',srcs);  
        }
        img.setAttribute('srci',srci);
        img.setAttribute('srcs',srcs);
        img.addEventListener("click", (e) => {
          if (document.getElementsByClassName('lightbox-clicked').length > 0) {
            e.target.parentElement.parentElement.classList.remove('lightbox-clicked');
            img.setAttribute('src',srcs);
          } else {
            e.target.parentElement.parentElement.classList.add('lightbox-clicked');
            img.setAttribute('src',srci);
          }
        });
        ilbox.appendChild(img);
        if (imagetype == 0) {
          if (foldername.length > 0) {
            document.querySelector("#progphotos .gallery .directory[dirname='" + foldername.split('/')[0] + "'] .deletebutton").classList.add('hide');
            document.querySelector("#progphotos .gallery .directory[dirname='" + foldername.split('/')[0] + "']").appendChild(imgprev);
          } else {
            document.querySelector("#progphotos .gallery").appendChild(imgprev);
          }
          
        }
        else {
          document.querySelector("#orderid-" + imagetype + ' .gallery').appendChild(imgprev);
        }
      });
      } catch(e) {
        console.log('no-image');
      }
    },
    parsePhotos($event) {
      $event.preventDefault();
      const files = $event.target.files;
      var upfiles = [];
      var fnames = [];
      var readers = [];
      var foldername = $event.target.getAttribute('gofolder');
      var gallerytype = parseInt($event.target.parentElement.parentElement.parentElement.id.split('rderid-')[1]) ? parseInt($event.target.parentElement.parentElement.parentElement.id.split('rderid-')[1]) : 0;
      for (let i = 0; i < files.length; i++) {
        try { 
          var file = files[i];
          fnames[i] = file.name;
          readers[i] = new FileReader();
          readers[i].addEventListener(
            "load",
            () => {
              // convert image file to base64 string
              var filedata = readers[i].result; 
              document.querySelector('#uploadstring').value = document.querySelector('#uploadstring').value + filedata + "|";
              var imgprev = document.createElement('span'); imgprev.classList.add("imageprev");
              var ilbox = document.createElement('span'); ilbox.classList.add('lightbox');
              var ilboxdeleteimg = document.createElement('span'); ilboxdeleteimg.classList.add('delete');
              ilboxdeleteimg.addEventListener("click", (e) => {
                e.target.parentElement.parentElement.remove();
              });
              ilbox.appendChild(ilboxdeleteimg);
              imgprev.appendChild(ilbox);

              var img = document.createElement('img');
              img.setAttribute('src',filedata);
              img.addEventListener("click", (e) => {
                if (document.getElementsByClassName('lightbox-clicked').length > 0) {
                  e.target.parentElement.parentElement.classList.remove('lightbox-clicked');
                } else {
                  e.target.parentElement.parentElement.classList.add('lightbox-clicked');
                }
              });
              ilbox.appendChild(img);
              
            
              if (gallerytype > 0) {
                $event.target.parentElement.appendChild(imgprev);
              } else {
                document.querySelector(".directory[dirname='" + foldername + "'] ").appendChild(imgprev);
              }

              if (i+1 == files.length) {
                this.imageform.upfile = document.querySelector('#uploadstring').value;
                this.imageform.gallerytype = gallerytype;
                this.imageform.foldername = foldername;
                this.imageform.fname = JSON.stringify(fnames);
                this.imageform.put(`/daylogs/${this.daylog.id}/savephotos/`);
                this.imageform.reset();
              }

            },
            false
          );
          readers[i].readAsDataURL(file);
        } catch(e) { console.log("not uploaded:", e);  }
      }
    },
    createFolder($event) {
      $event.preventDefault();
      var regex = new RegExp(/[A-Z0-9\ ]/gmi);
      var foldername = (document.querySelector('#newfolder').value.match(regex) || []).join('');
      document.querySelector('#newfolder').value = '';
      this.imageform.foldername = foldername;
      if ((typeof(foldername) !== 'undefined') && (foldername !== '')) {
        var gallerytype = parseInt($event.target.parentElement.parentElement.parentElement.id.split('rderid-')[1]) ? parseInt($event.target.parentElement.parentElement.parentElement.id.split('rderid-')[1]) : 0;
        this.imageform.gallerytype = gallerytype;
        this.imageform.daylog = this.daylog.id;
        this.imageform.jobsite = this.daylog.jobsite_id;
        this.imageform.put(`/daylogs/makefolder/`);

        var directory = document.createElement('div');
        directory.classList.add('directory');
        var dirtitle = document.createElement('h3');
        dirtitle.classList.add('foldertitle');
        var dirnamecheck = foldername;


        var uploadclicker = document.createElement('button');
        uploadclicker.classList.add('uploadbutton');
        uploadclicker.setAttribute('gtype',gallerytype);
        uploadclicker.setAttribute('dirname',dirnamecheck);
        uploadclicker.innerText = 'Upload';
        uploadclicker.addEventListener("click", (e) => {
          document.querySelector('#uploader').setAttribute('gofolder',dirnamecheck);
          document.querySelector('#uploader').click();
        });

        var deleteclicker = document.createElement('button');
        deleteclicker.classList.add('deletebutton');
        deleteclicker.setAttribute('gtype',gallerytype);
        deleteclicker.setAttribute('dirname',dirnamecheck);
        deleteclicker.innerText = 'Delete Folder';
        deleteclicker.addEventListener("click", (e) => {
          //var gtype = e.target.getAttribute('gtype');
          this.deleteFolder(e);
        });
        dirtitle.innerText = dirnamecheck;
        directory.setAttribute('dirname',dirnamecheck);
        directory.appendChild(dirtitle);
        directory.appendChild(uploadclicker);
        directory.appendChild(deleteclicker);
        if (gallerytype == 0) {
          var galselector = '#progphotos .progphotos-gallery.gallery';
        } else if (gallerytype > 0) {
          var galselector = '#orderid-' + gallerytype + ' .inventory-gallery.gallery';
        }
        document.querySelector(galselector).appendChild(directory);
      }

    },
    deleteFolder($event) {
      $event.preventDefault();
      $event.target.parentElement.remove();
      this.imageform.daylog = this.daylog.id;
      this.imageform.jobsite = this.daylog.jobsite_id;
      this.imageform.foldername = $event.target.getAttribute('dirname');
      this.imageform.gallerytype = $event.target.getAttribute('gtype');
      this.imageform.put(`/daylogs/deletefolder/`);
    },
    resize(ta) {
        var heightLimit = 600;
        var tar = document.getElementById(ta);
        
        tar.style.height = ""; /* Reset the height*/
        tar.style.height = Math.min(tar.scrollHeight, heightLimit) + "px";
    },
    saveitems() {
      event.preventDefault();
      this.daylog.workersummary = this.tabledata;
      this.form.workersummary = this.tabledata;
      
    },
    update() {
      event.preventDefault();
      if (document.querySelector('#workersum').value.length > 0) {
        var tdata =  JSON.parse(document.querySelector('#workersum').value);
        this.form.workersummary = JSON.stringify(tdata);
      } else { 
        try { 
          var tdata = JSON.parse(document.querySelector('#workersum').value);
          this.form.workersummary = JSON.stringify(tdata);  
        } catch(e) { }
        console.error(' Tabledata failure ')
      }
        this.daylog.signature = document.querySelector('#signaturedata').value;
        this.form.signature = document.querySelector('#signaturedata').value;
        this.form.put(`/daylogs/${this.daylog.id}`);
    },
    finalize() {
      event.preventDefault();
      if (document.querySelector('#workersum').value.length > 0) {
        var tdata =  JSON.parse(document.querySelector('#workersum').value);
        this.form.workersummary = JSON.stringify(tdata);
      } else {
        
        var tdata = JSON.parse(document.querySelector('#workersum').value);
        this.form.workersummary = JSON.stringify(tdata);  
        console.error(' Tabledata failure ')
      }
      
      this.daylog.signature = document.querySelector('#signaturedata').value;
        this.form.signature = document.querySelector('#signaturedata').value;
      this.form.put(`/daylogs/${this.daylog.id}`);
    },
    savesig() {
      event.preventDefault();
      var nv = this.signature1.save();
      this.daylog.signature = nv;
      this.form.signature = nv;
    },
    initAllProductsDeltas() {
      if (typeof(this.orders.data) !== 'undefined') {
        //var gdata = document.querySelector('#ordersdata').getAttribute('data');
        var gdata = JSON.stringify(this.orders.data);
        var gorders = Object.values(JSON.parse(gdata));
      } else {
        var gorders = Object.values(JSON.parse(JSON.stringify(this.orders)));
      }
      if (gorders) {
        gorders.forEach((order, ok) => {
          var daylogdata = JSON.parse(JSON.stringify(this.daylogs.data)).orderupdates;
          try { var oups = daylogdata; } catch(e) { console.warn('no-orderupdates',e)};
          //var oups = JSON.parse(JSON.parse(document.querySelector('#daylogdata').getAttribute('data')).orderupdates);
          try {
            if (oups) {
            if (oups.orders) {
            if (oups.orders[order.id]) {
              oups.orders[order.id].forEach((oup,prid) => {
                var sel = '#inv-changer-' + order.id + '-' + (prid+1);
                if (oup) {
                  document.querySelector(sel).value = oup;
                  this.newtotal(order.id,(prid+1));
                }
              });
            }
            }
            }
          } catch(e) { console.warn(e)     }
          try {
            if (oups) {
            if (oups.ordersAdd) {
            if (oups.ordersAdd[order.id]) {
              oups.ordersAdd[order.id].forEach((oup,prid) => {
                var sel = '#inv-adder-' + order.id + '-' + (prid+1);
                if (oup) {
                  document.querySelector(sel).value = oup;
                  this.newtotal(order.id,(prid+1));
                }
              });
            }
            }
            }
          } catch(e) {  }
        });
      }
      this.getPhotos();
    },
    reportdaylocal(formday) {
      var localday = moment(formday, 'YYYY-MM-DDT').utc().local().format('MM/DD/YYYY');
      return localday;
    },
    getProductSubtotal(qty,orderid,productid) {
      return parseInt((qty + "").replace(',','')) - this.getProductDelta(orderid,productid);
    },
    getProductDelta(orderid,productid) {
      var ret = "";
      try { var oups = JSON.parse(this.daylog.orderupdates); } catch(e) { console.warn(e); var oups = ''; }
      if (oups && oups.legnth > 0 ) { 
        ret = oups.orders[orderid][productid];
      } 
      return ret;
    },
    qtyCurrent() {
      
      Object.values(this.orders).forEach((o) =>  {  
        
      var projnets = [];
        try { 
            if (o.products) {
              if (o.products.length > 0) {
                var op = JSON.parse(o.products);
                op.forEach((opr,productkey) => { 
                  
                  if (
                    (typeof(projnets[productkey]) == "undefined") ||
                    (projnets[productkey] == null) ||
                    (projnets[productkey] == "")
                  ) { projnets[productkey] = 0; }

                  if (opr.qty_ordered && opr.projected_delivery) {
                    projnets[productkey] += parseInt(opr.qty_ordered);
                  } 

                })
              }
            }
        } catch(e) { console.log(e); }
        //delta this order
        try { 
          var p = JSON.parse(o.products);

          if (typeof(p) !== 'undefined' || p !== '' || p.length < 1) {
            this.purchaseorders.data.forEach( (v) => {
              if (v.id == o.purchaseorder_id) {
                p = JSON.parse(v.products);
              }
            });
          }

          p.forEach((opr,productkey) => { 
              //projnets[productkey] = projnets[productkey] - parseInt(opr.quantity);
              try { document.getElementById('inv-po-' + o.id + '-' + (productkey+1)).innerText = (opr.quantity).toString(); }
              catch(e) { console.warn(e); }
              //console.log(opr);

          });
        } catch(e) {
          console.error(e);
        }

        projnets.forEach((v,k) => {
          try {
            document.getElementById('inv-current-' + o.id + '-' + (k+1)).innerText = ((v * -1) + (parseInt(document.getElementById('inv-po-' + o.id + '-' + (k+1)).innerText))).toString(); 
          }
          catch(e) {  console.warn(e); }
        });

      });


    },
    getInventoryCurrentTotals() {  
      var input = [this.notthisorders,this.order,this.purchaseorder];
      //var input = JSON.parse(document.getElementById('refreshnet').getAttribute('netcalc'));
      var ordersntorders = input[0];
      var order = input[1];
      var po = input[2];
      var projnets = [];
      ordersntorders.data.forEach((o,k) => {
        try { 
          if (o.editing) {
            if (o.products) {
              if (o.products.length > 0) {
                var op = JSON.parse(o.products);
                op.forEach((opr,productkey) => { 
                  
                  if (
                    (typeof(projnets[productkey]) == "undefined") ||
                    (projnets[productkey] == null) ||
                    (projnets[productkey] == "")
                  ) { projnets[productkey] = 0; }

                  if (opr.qty_ordered && opr.projected_delivery) {
                    projnets[productkey] += parseInt(opr.qty_ordered);
                  } 

                })
              }
            }
          }
        } catch(e) { console.log(e); }
      });

      //delta this order
      try { 
        var p = JSON.parse(order.products);

        if (typeof(p) !== 'undefined' || p !== '' || p.length < 1) {
          this.purchaseorder.data.forEach( (v) => {
            if (v.id == this.order.purchaseorder_id) {
              p = JSON.parse(v.products);
            }
          });
        }

        p.forEach((opr,productkey) => { 
            projnets[productkey] = 0;

        });
      } catch(e) {
        console.error(e);
      }

      var keycheck = 1;
      var poqtys = JSON.parse(po.data[0].products);
      while (document.querySelectorAll('.tabulator-row').length > keycheck-1) {
        //var poselector = document.querySelector('.tabulator-row:nth-child(' + keycheck + ') .poqty');
        //try { var poqty = parseInt(poselector.innerHTML.split('.')[0].replace(',','').replace(',','')); }
        //catch(e) { var poqty = poselector.innerHTML; }
        try { 
          var poqtyparser = poqtys[keycheck-1].quantity.toString();
          var poqty = parseInt(poqtyparser.replace(',','').replace(',',''));
          var projecteddelta = parseInt(projnets[keycheck-1].toString().replace(',',''));
          document.querySelector('.tabulator-row:nth-child(' + keycheck + ') .colspacer').innerHTML =
              (poqty - projecteddelta);

          if ((poqty - projnets[keycheck-1]) < 1) {
            document.querySelector('.tabulator-row:nth-child(' + keycheck + ') .colspacer').classList.add('red');
          } else {
            document.querySelector('.tabulator-row:nth-child(' + keycheck + ') .colspacer').classList.add('netproj');
          }
        }
        catch(e) { console.log(e); }
        keycheck++;
      }      
        document.querySelector('#orderstable').classList.remove('loading');
    },
    newtotal(orderid,loopid) {
      //var current = parseInt(document.querySelector('#inv-current-' + orderid + '-' + loopid).innerHTML.replace(',',''));
      //var delta = parseInt(document.querySelector('#inv-changer-' + orderid + '-' + loopid).value.replace(',',''));
      //var newtotalval = current - delta;
      //document.querySelector('#inv-newtotal-' + orderid + '-' + loopid).innerHTML = newtotalval;
      this.packageOrderUpdates();
    },
    newtotalAdd(orderid,loopid) {
      //var current = parseInt(document.querySelector('#inv-current-' + orderid + '-' + loopid).innerHTML.replace(',',''));
      //var delta = parseInt(document.querySelector('#inv-adder-' + orderid + '-' + loopid).value.replace(',',''));
      //var newtotalval = current + delta;
      //document.querySelector('#inv-newtotal-' + orderid + '-' + loopid).innerHTML = newtotalval;
      this.packageOrderUpdates();
    },
    packageOrderUpdates() {
/*
      var orderPackage = {};
      orderPackage.orders = [];
      this.orders.forEach((order) =>  {
        orderPackage.orders[order.id] = [];
        if (order.products) {
          JSON.parse(order.products).forEach((invrow,ikey) => {
            var testproductchangeval = parseInt(document.querySelector('#inv-changer-' + order.id + '-' + (ikey+1)).value.replace(',',''));
            if ((testproductchangeval !== 0) && (testproductchangeval !== null) && (testproductchangeval !== "") && (testproductchangeval !== "null")) {
              orderPackage.orders[order.id][ikey] = testproductchangeval;
            }
          });
        }
      });
      this.form.orderupdates = JSON.stringify(orderPackage);
*/

      var orderPackage2 = {};
      orderPackage2.ordersAdd = [];
      Object.values(this.orders).forEach((order) =>  {
        orderPackage2.ordersAdd[order.id] = [];
        if (order.products) {
          Object.values(JSON.parse(order.products)).forEach((invrow,ikey) => {
            var testproductchangeval = 0;
            testproductchangeval = parseInt(document.querySelector('#inv-adder-' + order.id + '-' + (ikey+1)).value.replace(',',''));
            orderPackage2.ordersAdd[order.id][ikey] = (testproductchangeval > 0 ? testproductchangeval : null);
          });
        }
      });
      this.form.orderupdates = JSON.stringify(orderPackage2);

    },
    destroy() {
      if (confirm('Are you sure you want to delete this day log?')) {
        this.$inertia.delete(`/daylogs/${this.daylog.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this day log?')) {
        this.$inertia.put(`/daylogs/${this.order.id}/restore`)
      }
    },
    isPos($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode == 45) || (keyCode == 46)) { // dash
          $event.preventDefault();
      }
    },
    isNumFix($event) {
      return true;
    }
  },
}
</script>
<script setup>
  import {reactive, ref} from 'vue'
  
  const state = reactive({
    count: 0,
    option: {
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgb(242,242,242)"
    },
    disabled: false,
  })

    const signature1 = ref(null);
 
  const save = (t) => {
    event.preventDefault();
    var nv = signature1.value.save('image/svg+xml');
    document.querySelector('#signaturedata').value = nv;
    //form.signature = nv;
    return nv;
    //this.save2(saveval);
  }
  
  const clear = () => {
    event.preventDefault();
    signature1.value.clear()
  }
  
  const undo = () => {
    event.preventDefault();
    signature1.value.undo();
  }
  
  const addWaterMark = () => {
    event.preventDefault();
    signature1.value.addWaterMark({
      text: "mark text",          // watermark text, > default ''
      font: "20px Arial",         // mark font, > default '20px sans-serif'
      style: 'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
      fillStyle: "red",           // fillcolor, > default '#333'
      strokeStyle: "blue",	       // strokecolor, > default '#333'
      x: 100,                     // fill positionX, > default 20
      y: 200,                     // fill positionY, > default 20
      sx: 100,                    // stroke positionX, > default 40
      sy: 200                     // stroke positionY, > default 40
    });
  }
  
const fromDataURL = (url) => {
  event.preventDefault();
  signature1.value.fromDataURL(url);
}

  const handleDisabled = () => {
    event.preventDefault();
    state.disabled = !state.disabled
  }




const getDayString = (rday) => {
        var rdaytext = '';
        if (rday.indexOf('/') > 0) {
          var rdaytext = moment(rday,"MM/DD/YYYY").format('dddd, MMMM DD, YYYY');
        } else if (rday.indexOf('-') < 1) {
          var rdaytext = moment(rday,"YYYYMMDD").format('dddd, MMMM DD, YYYY');
        } else if (rday.indexOf('-') > 1) {
          var rdaytext = moment(rday).format('dddd, MMMM DD, YYYY');
        }
        return (rdaytext == 'Invalid date') ? "" : rdaytext;
    };
  
var tabledata = [
    
    ];
  

const addRow = () => {
    event.preventDefault();
    Table.addData([{workertype:'', manpower:0, workdesc:0 }])
};

const resize = function(ta) {
  var heightLimit = 600;
  var tar = document.getElementById(ta);
  
  tar.style.height = ""; /* Reset the height*/
  tar.style.height = Math.min(tar.scrollHeight, heightLimit) + "px";
};

var Table;
window.setTimeout(function() {
  Table = new Tabulator("#workersumtable", {
    reactiveData:false, //enable reactive data
    data:this.tabledata,
    //rowHeight:60,
    layout:"fitDataStretch",
    columns:[
    {title:"Worker Type",width:120,field:"workertype",editor:"input"},
    {title:"Manpower",field:"manpower",editor:"number",editorParams:{min:0,max:9999999999,step:1},bottomCalc:"sum", bottomCalcParams:{precision:0}},
    {title:"Work Performed",field:"workdesc",editor:"textarea", formatter:"textarea",width:400, widthShrink:2,variableHeight:true },
    {title:"",width:70,cssClass:"workerdelete",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() {  { cell.getRow().delete(); } },5); }},
    ]
  });


  Table.on("cellEdited", function(cell) {
    tabledata = Table.getData();
    document.querySelector('#workersum').value = JSON.stringify(tabledata);
  });

    
  window.setTimeout(function() {
    var pdval = document.querySelector('#workersum').value;
    if ((typeof(pdval) !== 'undefined') && (pdval.length > 0)) {
      Table.replaceData(JSON.parse(document.querySelector('#workersum').value));
    }
  },1);
  document.querySelector('#bigloading').classList.remove('loading');
},50);
</script>